import * as React from "react";

const SliderError = (props: { message?: string; reload?: () => void }) => {
	return (
		<div
			data-test="cshp-recommendation-error"
			className="csrec-card csrec-card-error"
		>
			<svg
				data-test="cshp-recommendation-sad-face"
				xmlns="http://www.w3.org/2000/svg"
				width="99"
				height="64"
			>
				<g fill="#E5E5E5" fillRule="evenodd">
					<circle cx="7.5" cy="7.5" r="7.5" />
					<circle cx="92" cy="7" r="7" />
					<path d="M17.434 64.051C38.859 46.235 64.477 46.235 85 62.45 71.386 30.4 32.717 30.4 17.434 64.051z" />
				</g>
			</svg>
			<div className="csrec-card-error-message">
				<span className="icn-messaging-error-sm"></span>
				<span data-test="cshp-recommendation-error-message" className="text">
					{props.message || "Hmm, we couldn't load solutions."}{" "}
					{!props.message && (
						<>
							<br className="media-visible-on-mobile" />
							<span
								data-test="cshp-recommendation-try-again"
								className="csrec-link csrec-reload-link"
								onClick={props.reload ? e => props.reload() : null}
							>
								Try again
							</span>
						</>
					)}
				</span>
			</div>
		</div>
	);
};

SliderError.displayName = "SliderError";
export default SliderError;
